<template>
  <div id="accountview">
    <NavBar />

    <AccountOverview
      @open-support="openSupport"
    />

    <SiteFooter />
  </div>

  <FloatingSupport
    ref="floatingSupport"
    :support-open="supportOpen"
    @close="supportOpen = false"
  />
</template>

<script>
import { ref, nextTick } from 'vue';

import AccountOverview from './AccountOverview.vue';
import NavBar from '@/components/NavBar.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import FloatingSupport from '@/components/Modals/FloatingSupport.vue';

export default {
  name: 'AccountView',

  components: {
    AccountOverview,
    NavBar,
    SiteFooter,
    FloatingSupport
  },

  setup() {
    const supportOpen = ref(false);
    const floatingSupport = ref(null);

    const openSupport = async () => {
      // Open the floating support
      supportOpen.value = true;

      // Wait for FloatingSupport to render
      await nextTick();

      // Open in ticket mode
      if (floatingSupport.value) {
        floatingSupport.value.mode = 'ticket';
      }
    };

    return {
      supportOpen,
      floatingSupport,
      openSupport
    };
  }
};
</script>